import MuiTooltip from '@mui/material/Tooltip'
import { styles } from './Tooltip.style'

export const Tooltip = ({ className, arrow = true, disable = false, disableInteractive = true, children, ...props }) => {
  if (disable) {
    return children
  }

  return <MuiTooltip
    {...props}
    arrow={arrow}
    disableInteractive={disableInteractive}
    componentsProps={{
      arrow: {
        sx: styles.arrow
      },
      tooltip: {
        sx: styles.tooltip
      }
    }}
  >
    {children}
  </MuiTooltip>
}
